// extracted by mini-css-extract-plugin
export default {"heading":"Et-z","corrected":"Ft-z","redirectVerbiageContainer":"Gt-z","redirectVerbiageText":"Ht-z"};